import type { AttendeeType } from "../../../Enums/RegistrationEnum";
import { IEvent } from "../../../interfaces/models/IEvent";
import { IRegistration } from "../../../interfaces/models/IRegistration";
import type { PaymentHistoryColumn, RegistrantHistoryColumn } from "./types";

export function createRegistrationDraft(
  eventId: string,
  eventData?: IEvent,
): IRegistration {
  const now = Math.floor(Date.now() / 1000);
  return {
    eventId,
    eventName: eventData?.title,
    eventDate: eventData?.startDate,
    eventType: eventData?.eventType,
    personId: "",
    status: "attending",
    attendeeType: "regular" as AttendeeType,
    badgeName: "",
    paymentStatus: "pending",
    registrationDate: now,
    amountPaid: 0,
    createdFrom: "staff",
  };
}

export const REGISTRANT_HISTORY_COLUMNS: RegistrantHistoryColumn[] = [
  { id: "index", header: "#" },
  { id: "date", header: "Date" },
  { id: "type", header: "Type" },
  { id: "info", header: "Info Modified" },
  { id: "modifiedBy", header: "Modified By" },
];

export const PAYMENT_HISTORY_COLUMNS: PaymentHistoryColumn[] = [
  { id: "index", header: "#" },
  { id: "logDate", header: "Modification Date" },
  { id: "paymentDate", header: "Payment Date" },
  { id: "status", header: "Status" },
  { id: "paymentMethod", header: "Payment Method" },
  { id: "amount", header: "Payment" },
  { id: "savedBy", header: "Updated By" },
  { id: "note", header: "Notes" },
];
